import axios from 'axios';
import { toast } from 'sonner';

/**
 * Pengingat admin saat menugaskan nakes (Okt 2026, tahap 2 izin lokasi).
 *
 * Setelah penugasan BERHASIL, cek apakah nakes yang ditugaskan sudah mengaktifkan izin lokasi.
 * Kalau belum, tampil satu pengingat: minta nakes menyalakan lokasi. Penugasan sendiri tidak
 * pernah dihalangi atau diubah, dan semua kegagalan di sini diabaikan diam-diam.
 *
 * Satu pencegat respons menutup semua layar penugasan yang memakai axios; layar yang memakai fetch
 * memanggil remindLocationForAssign() langsung.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Mengenali jalur penugasan: /orders/{id}/assign, /orders/{id}/assign/{nakes}, /assignments/add, /assignments/reassign
const ASSIGN_URL = /\/orders\/[^/?#]+\/(?:assign(?:\/([^/?#]+))?|assignments\/(?:add|reassign))\/?(?:[?#].*)?$/;

let lastReminderKey = '';
let lastReminderAt = 0;

export async function remindLocationForAssign(userIds, token) {
  try {
    const ids = [...new Set((userIds || []).filter((x) => typeof x === 'string' && x))].slice(0, 50);
    if (!ids.length) return;
    const t = token || localStorage.getItem('token');
    const r = await axios.post(`${API}/admin/nakes/location-status`, { user_ids: ids },
      { headers: { Authorization: `Bearer ${t}` }, timeout: 8000 });
    const list = r?.data?.not_active || [];
    if (!list.length) return;
    // Hindari pengingat yang sama muncul berulang dalam waktu dekat (mis. penugasan ulang berurutan).
    const key = list.map((n) => n.user_id).sort().join(',');
    if (key === lastReminderKey && Date.now() - lastReminderAt < 60 * 1000) return;
    lastReminderKey = key;
    lastReminderAt = Date.now();
    const names = list.map((n) => n.name).join(', ');
    toast.warning(
      `Izin lokasi belum aktif: ${names}. Ingatkan nakes untuk menyalakan lokasi di HP. Penugasan tetap berhasil.`,
      { id: 'loc-reminder', duration: 12000 },
    );
  } catch {
    /* pengingat tidak boleh mengganggu penugasan */
  }
}

function idsFromRequest(config, match) {
  const ids = [];
  if (match[1]) ids.push(decodeURIComponent(match[1])); // /assign/{nakes_id}
  try {
    const body = typeof config.data === 'string' ? JSON.parse(config.data) : (config.data || {});
    if (Array.isArray(body.nurse_user_ids)) ids.push(...body.nurse_user_ids);
    if (Array.isArray(body.user_ids)) ids.push(...body.user_ids);
    if (typeof body.to_user_id === 'string') ids.push(body.to_user_id);
  } catch {
    /* body bukan JSON: abaikan */
  }
  return ids;
}

let installed = null;

export function installLocationAssignReminder() {
  if (installed) return installed;
  const id = axios.interceptors.response.use((response) => {
    try {
      const cfg = response?.config;
      if (cfg && String(cfg.method || '').toLowerCase() === 'post') {
        const m = ASSIGN_URL.exec(String(cfg.url || ''));
        if (m) {
          const auth = cfg.headers?.Authorization || cfg.headers?.authorization || '';
          remindLocationForAssign(idsFromRequest(cfg, m), String(auth).replace(/^Bearer\s+/i, '') || undefined);
        }
      }
    } catch {
      /* pengingat tidak boleh mengubah hasil permintaan */
    }
    return response;
  });
  installed = () => {
    axios.interceptors.response.eject(id);
    installed = null;
  };
  return installed;
}
